import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormat';

import { parseErknmValue } from './parseErknmValue';
import { IErknmPeriodExtension } from '../interfaces/IErknmPeriodExtension';

export const getPeriodExtension = (
  passportData: IKnmPreview | undefined,
  erknmField: 'pmErknm' | 'inspectionErknm',
) => {
  const periodExtensions: IErknmPeriodExtension[] = [];

  passportData?.[erknmField]?.events?.forEach(item => {
    // @ts-ignore
    if (item.periodExtension) {
      const eventValue = item.event?.value && parseErknmValue<{ title?: string }>(item.event.value);

      const addedPeriodExtension: IErknmPeriodExtension = {
        // @ts-ignore
        ...item.periodExtension,
        decisionDateTime:
          // @ts-ignore
          item.periodExtension?.decisionDateTime &&
          // @ts-ignore
          formatDate({ date: item.periodExtension.decisionDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE }),
        event: eventValue && eventValue.title,
      };

      periodExtensions.push(addedPeriodExtension);
    }
  });

  periodExtensions.sort((a, b) => {
    return a.dateCreate && b.dateCreate ? new Date(a.dateCreate).valueOf() - new Date(b.dateCreate).valueOf() : 0;
  });

  return periodExtensions;
};
